import { render, staticRenderFns } from "./EditableLabelChatPage.vue?vue&type=template&id=a45b6f80&scoped=true&"
import script from "./EditableLabelChatPage.vue?vue&type=script&lang=js&"
export * from "./EditableLabelChatPage.vue?vue&type=script&lang=js&"
import style0 from "./EditableLabelChatPage.vue?vue&type=style&index=0&id=a45b6f80&lang=scss&scoped=true&"
import style1 from "./EditableLabelChatPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45b6f80",
  null
  
)

export default component.exports